import { render, staticRenderFns } from "./EditGovernmentForm.vue?vue&type=template&id=5b367190&scoped=true&"
import script from "./EditGovernmentForm.vue?vue&type=script&lang=js&"
export * from "./EditGovernmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b367190",
  null
  
)

export default component.exports